import { Container } from 'inversify'
import { ReplaceDomainService } from './ReplaceDomainService'
import { SERVICES as SERVICES_COMMON } from '../Base/serviceRegistration'
import { HttpRequestContext } from '../Utils/HttpRequestContext'
import { DomainService } from './DomainService'

export const SERVICES = {
  ReplaceDomainService: Symbol.for('ReplaceDomainService'),
}

export function registerBinding(container: Container): void {
  container.bind<() => DomainService>(SERVICES.ReplaceDomainService).toConstantValue(() => {
    const httpRequestContext = container.get<HttpRequestContext>(SERVICES_COMMON.HttpRequestContext)
    return new ReplaceDomainService(httpRequestContext)
  })
}

//  DON'T DELETE - used by DW
